import React from 'react'
import { SvgIconProps } from './Home'

const SvgCalendarIcon = ({ fill, className }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    className={className}
  >
    <path
      fill={fill ?? "#353535"}
      d="M16.158 2.421h-.948V1h-1.894V2.421H6.684V1H4.79V2.421h-.947C2.232 2.421 1 3.653 1 5.168v11.085C1 17.768 2.232 19 3.842 19h12.316C17.768 19 19 17.768 19 16.253V5.168c0-1.515-1.232-2.747-2.842-2.747zm.947 5.495v8.242a.95.95 0 01-.947.947H3.842c-.568 0-.947-.379-.947-.947V7.916h14.21zM5.263 5.168H6.684v-.947h6.632v.947H15.21v-.947h.948c.568 0 .947.379.947.947v.948H2.895v-.948a.95.95 0 01.947-.947h.947v.947h.474z"
    ></path>
  </svg>
)


export default SvgCalendarIcon